// extracted by mini-css-extract-plugin
export default {"r_l":"_8ab07f92c4 _802bbce9ab","t":"_2da33b5eed"};